import { Component, Inject, OnDestroy, OnInit, Optional } from '@angular/core';
import { DialogRef } from '../modal-dialogue/modal-dialogue.ref';
import { DIALOG_DATA } from '../../../../global.variable';
import { firstValueFrom, Subscription } from 'rxjs';
import { DeviceInfoService } from '../../services/device-info.service';
import { DomSanitizer } from '@angular/platform-browser';
import { PagesService } from '../../../pages/pages/pages.service';
import { gTDB } from '../../services/db';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { ModelDialogueService } from '../modal-dialogue/model-dialogue.service';
import { UserProfileService } from '../../../profile/user-profile/user-profile.service';
import { SqliteDbService } from '../../services/sqlite-db.service';

@Component({
  selector: 'gtapp-queued-events',
  standalone: false,
  templateUrl: './queued-events.component.html',
  styleUrl: './queued-events.component.scss',
})
export class QueuedEventsComponent implements OnInit, OnDestroy {
  showFrom: string = 'home';
  queuedResposeListData: any = [];

  offlineMode: boolean = false;
  syncInProgress: boolean = false;

  deviceInfoSubscription: Subscription = new Subscription();
  pendingItemCount: number = 0;
  constructor(
    @Optional() protected dialogRef: DialogRef,
    private deviceInfoService: DeviceInfoService,
    @Inject(DIALOG_DATA) public dialogData: any,
    private sanitizer: DomSanitizer,
    private pageService: PagesService,
    private dialogService: ModelDialogueService,
    private profileService: UserProfileService,
    private sqliteDb: SqliteDbService,
  ) {}
  ngOnDestroy(): void {
    if (this.deviceInfoSubscription) this.deviceInfoSubscription?.unsubscribe();
  }

  ngOnInit(): void {
    this.pendingItemCount = (this.dialogData?.queuedResposeListData || [])
      ?.length;
    this.retryAllQueuedEvents();
    this.queuedResposeListData = this.dialogData?.queuedResposeListData || [];
    this.showFrom = this.dialogData?.showFrom || this.showFrom;
    this.deviceInfoSubscription =
      this.deviceInfoService.deviceInfoSubject.subscribe((value: any) => {
        if ('appStatus' in value) {
          this.offlineMode = !value?.appStatus;
        }
        if ('syncItemsInDb' in value) {
          this.getItemsInIndexDb();
        }

        if ('syncComplete' in value) {
          this.getItemsInIndexDb(true);
        }
      });
  }
  syncData() {
    this.pageService.miscSubjectParam.next({ syncData: true });
    this.syncInProgress = true;
  }
  async retryAllQueuedEvents() {
    const apiResponseDict: any =
      (await gTDB.userData.get('apiResponseDict')) || {};
    this.queuedResposeListData?.forEach((update: any) => {
      delete apiResponseDict[update?.indexDBId];
    });
    await gTDB.userData.put(apiResponseDict, 'apiResponseDict');
    this.syncData();
  }
  async deleteQueuedItem(item: any) {
    const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
      data: {
        title: 'Are you sure?',
        message: 'THIS ACTION CANNOT BE UNDONE!',
        btn2Detail: { text: 'Delete', class: 'btn-danger' },
      },
    });
    const dResponse = await firstValueFrom(dialogRef.afterClosed());
    if (dResponse === true) {
      if (item?.isInNativeDb) {
        try {
          await this.sqliteDb.deleteSavedUpdateRow(
            item?.event_source,
            item?.indexDBId,
          );
        } catch (error) {
          throw error;
        }
      } else {
        gTDB.gtSavedData.bulkDelete([item?.indexDBId]);
      }

      this.getItemsInIndexDb();
      const deletedItem = this.queuedResposeListData?.find(
        (item: any) => item?.indexDBId == item?.indexDBId,
      );
      if (!deletedItem?.indexDBId) return;

      let scanOnly = false;
      let qr_text: any;
      try {
        const formData = JSON.parse(deletedItem?.form_data || '{}');
        scanOnly = formData?.scanOnly || false;
        qr_text = formData?.qr_text || '';
      } catch (error) {}

      const reqData = {
        index_db_id: deletedItem?.indexDBId,
        recorded_at: deletedItem?.updated_at,
        additional_info: {
          device_info: deletedItem?.device_info,
          event_info: {
            company_id: deletedItem?.company_id,
            job_id: deletedItem?.job_id,
            path_name: deletedItem?.pathName,
            site_id: deletedItem?.site_id,
            file_size: deletedItem?.file?.size,
            check_point_id: deletedItem?.check_point_id,
            qr_text: qr_text,
            scanOnly: scanOnly,
          },
        },
      };
      if (this.offlineMode) {
        const deletedQueuedItemList = JSON.parse(
          localStorage.getItem(btoa('deletedQueuedItemList')) || '[]',
        );
        deletedQueuedItemList.push(reqData);
        localStorage.setItem(
          btoa('deletedQueuedItemList'),
          JSON.stringify(deletedQueuedItemList),
        );
      } else {
        this.profileService
          .logQueuedStaleUpdates({ data: [reqData] }, { log_deleted: 1 }, false)
          .then((res: any) => {});
      }
    }
  }
  deleteAllItems() {
    const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
      data: {
        title: 'Are you sure?',
        message: 'THIS ACTION CANNOT BE UNDONE!',
        btn2Detail: { text: 'Delete', class: 'btn-danger' },
      },
    });
    dialogRef.afterClosed().subscribe((dialogResponse) => {
      if (dialogResponse === true) {
        const itemIds = this.queuedResposeListData?.map((item: any) =>
          parseInt(item?.indexDBId, 10),
        );
        gTDB.gtSavedData.bulkDelete(itemIds);
        this.getItemsInIndexDb();
      }
    });
  }
  async retryQueuedItem(item: any) {
    const apiResponseDict: any =
      (await gTDB.userData.get('apiResponseDict')) || {};

    delete apiResponseDict[item?.indexDBId];

    await gTDB.userData.put(apiResponseDict, 'apiResponseDict');
    this.syncData();
  }
  getImgSrc(file: File) {
    let url = URL.createObjectURL(file);

    return this.sanitizer.bypassSecurityTrustUrl(url);
  }
  onDialogClose(val = false) {
    this.dialogRef.close(val);
  }
  async getItemsInIndexDb(syncCompleteCheck = false) {
    const [queuedResposeListData, _] =
      await this.pageService.getSavedItemsInClientDb();
    this.queuedResposeListData = queuedResposeListData;
    if (
      syncCompleteCheck &&
      (!this.queuedResposeListData?.length ||
        this.queuedResposeListData?.every(
          (item: any) => item?.errorMessages?.length,
        ))
    ) {
      this.syncInProgress = false;
    }
  }
}
